import { toast } from "react-toastify"

/**
 * Reusable toast message handler
 */
export const useToastMessage = () => {
  /**
   * Handle API response (success or failure)
   * @param {Object} response - API response
   * @param {string} defaultSuccessMessage - fallback success message
   */
  const handleResponse = (
    response,
    defaultSuccessMessage = "",
    isDefaultMessage = false
  ) => {
    if (!response) return

    if (response.success) {
      // Success message
      toast.success(
        isDefaultMessage
          ? defaultSuccessMessage
          : response.message || defaultSuccessMessage
      )
    } else {
      // Failure message
      if (response.errors) {
        // Show field validation errors
        Object.values(response.errors).forEach(fieldErrors => {
          fieldErrors.forEach(msg => toast.error(msg))
        })
      } else if (response.message) {
        toast.error(response.message)
      } else {
        toast.error("Something went wrong.")
      }
    }
  }

  /**
   * Handle unexpected errors (network, server, etc.)
   */
  const handleError = (error, defaultErrorMessage = "Something went wrong") => {
    if (!error) return

    // Never surface raw server messages on 5xx (they can leak
    // implementation details such as curl errors or API keys).
    if (error.response?.status && error.response.status >= 500) {
      toast.error("A server error occurred. Please try again later.")
      return
    }

    if (error.response?.data?.errors) {
      const errors = error.response.data.errors
      Object.values(errors).forEach(fieldErrors => {
        fieldErrors.forEach(msg => toast.error(msg))
      })
    } else if (error.response?.data?.message) {
      toast.error(error.response.data.message)
    } else if (error.message) {
      toast.error(error.message)
    } else {
      toast.error(defaultErrorMessage)
    }
  }

  return { handleResponse, handleError }
}
